<h2 mat-dialog-title>QR-Etiketten drucken</h2>

<mat-dialog-content class="qr-dialog-content">
  <div class="options">
    <div class="option-group">
      <div class="option-label">Layout</div>
      <mat-radio-group [(ngModel)]="layout" [disabled]="content === 'website'">
        <mat-radio-button value="compact">Kompakt (2.5cm)</mat-radio-button>
        <mat-radio-button value="standard">Standard (gross)</mat-radio-button>
      </mat-radio-group>
      <div class="hint" *ngIf="content === 'website'">
        Webseite-QR verwendet immer das Standard-Layout.
      </div>
    </div>

    <div class="option-group">
      <div class="option-label">Inhalt</div>
      <mat-radio-group [(ngModel)]="content" (ngModelChange)="onContentChange()">
        <mat-radio-button value="indicator">Indikator-Code</mat-radio-button>
        <mat-radio-button value="website">Webseite (mit Logo)</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div class="selection-header" *ngIf="!loading && !error">
    <mat-checkbox
      [checked]="allSelected"
      [indeterminate]="someSelected"
      (change)="toggleAll($event.checked)">
      Alle auswählen
    </mat-checkbox>
    <span class="count">{{ selected.size }} / {{ indicators.length }} ausgewählt</span>
  </div>
  <div class="selection-hint" *ngIf="!loading && !error">
    Keine Auswahl = alle Indikatoren werden gedruckt.
  </div>

  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Indikatoren werden geladen...</span>
  </div>

  <div class="error" *ngIf="error">{{ error }}</div>

  <div class="indicator-list" *ngIf="!loading && !error">
    <div class="indicator-row" *ngFor="let ind of indicators">
      <mat-checkbox
        [checked]="selected.has(ind.id)"
        (change)="toggle(ind.id, $event.checked)">
        <span class="num">{{ formatNumber(ind.indikator_number) }}</span>
        <span class="name">{{ ind.name }}</span>
        <span class="sys" *ngIf="ind.system_id != null">ID: {{ ind.system_id }}</span>
      </mat-checkbox>
    </div>
    <div class="empty" *ngIf="indicators.length === 0">Keine Indikatoren vorhanden.</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="working">Abbrechen</button>
  <button mat-stroked-button color="primary" (click)="preview()" [disabled]="working || loading || !!error">
    <mat-icon>visibility</mat-icon>
    Vorschau
  </button>
  <button mat-flat-button color="primary" (click)="downloadPdf()" [disabled]="working || loading || !!error">
    <mat-icon>picture_as_pdf</mat-icon>
    PDF herunterladen
  </button>
</mat-dialog-actions>
